import {
  getRoleBasedFREData,
  getViewerAdminRoles,
  hasError,
  isPermanentDismissal,
  shouldDisplaySettingsTeachingBubble,
} from '@ms/yammer-data/dist/domains/roleBasedFREs/selectors';
import {
  RecurrentDismissableAppViewPropertyTypes,
  RoleBasedFREAppViewProperty,
} from '@ms/yammer-data/dist/state/appViewProperties/types';
import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useAndReportExperimentTreatment } from '../experiments';
import { useSelector } from '../useSelector';

type UseIsRoleBasedFREDismissed = (
  appViewPropertyKey: RecurrentDismissableAppViewPropertyTypes
) => RoleBasedFREAppViewProperty;
export const useRoleBasedFREAppViewProperty: UseIsRoleBasedFREDismissed = (appViewPropertyKey) =>
  useSelector((state) => getRoleBasedFREData(state, appViewPropertyKey));

export const useShowSettingsTeachingBubble = () => {
  const isExperimentEnabled = useAndReportExperimentTreatment(Experiment.RoleBasedFRE) === 'enabled';
  const shouldShowTeachingBubble = useSelector(shouldDisplaySettingsTeachingBubble);

  return isExperimentEnabled && shouldShowTeachingBubble;
};

type UseIsPermanentDismissal = (appViewPropertyKey: RecurrentDismissableAppViewPropertyTypes) => boolean;
export const useIsPermanentDismissal: UseIsPermanentDismissal = (appViewPropertyKey) =>
  useSelector((state) => isPermanentDismissal(state, appViewPropertyKey));

type UseViewerAdminRoles = () => ReturnType<typeof getViewerAdminRoles>;
export const useViewerAdminRoles: UseViewerAdminRoles = () => useSelector(getViewerAdminRoles);

type UseHasError = () => boolean;
export const useHasError: UseHasError = () => useSelector(hasError);
